import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";

const FieldInput = props => {
  const [tooltip, setTooltip] = useState(false);

  return (
    <div className={styles["field-outer"]}>
      <div className={styles["field-outer-label"]}>
        <label>
          {props.label} {props.infoText && <i>{props.infoText}</i>}
        </label>
        {props.tooltip && (
          <div className={styles["tooltip"]} onClick={() => setTooltip(!tooltip)}>
            <i>i</i>
            {tooltip && (
              <div className={styles["tooltip-frame"]}>
                {props.tooltip}
                <div onClick={() => setTooltip(!tooltip)} className={styles["close-div"]}>
                  x
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles["field-left"]}>
        <input
          type="text"
          value={props.newTax === 0 ? "" : props.newTax}
          onChange={e => {
            const re = /^[0-9\b]+$/;
            if (e.target.value === "" || re.test(e.target.value)) {
              const removeEmpty = e.target.value === "" ? 0 : e.target.value;
              props.updateField(removeEmpty);
            }
          }}
          className={styles["field"]}
          readOnly={props.readOnly}
        />
        <input type="text" value={props.extTax} className={styles["field"]} readOnly />
      </div>
    </div>
  );
};

FieldInput.propTypes = {
  extTax: PropTypes.string,
  newTax: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  tooltip: PropTypes.string,
  updateField: PropTypes.func,
  readOnly: PropTypes.bool,
  infoText: PropTypes.string
};

export default FieldInput;
